import { useEffect, useState, useCallback, ChangeEvent, FormEvent } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import { FileUploader } from "react-drag-drop-files";
import UploadIcon from '@mui/icons-material/Upload'; // ícono de subida
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description'; // XML icon substitute
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import MODAL_TABLE from "../../main_components/modal/modal_Table";
import { BREADCRUMBS } from "../../main_components/pagination/breadcrumbs";

import { refresh_token } from "../../main_components/tokens/tokenrefresh";
import { expense_payment_account_get, supplier_invoices_post } from "../../services/expenses/expense";

import envioPPDF from "../../imgComponents/pdf.png";
import envioXML from "../../imgComponents/xml.png";
import "./validador.css";

import SUPPLIER_INVOICE from "./tools/supplier_invoice";
import SUPPLIER_ORDERS from "./tools/supplier_orders";

import JSONRESPONSETEST from "./jsonresponse.json";

// Tipos
interface PaymentAccount {
  payment_method: string;
  payment_account: string;
  default?: boolean;
}

interface RequestData {
  files: { type: string; content: string }[];
  paymentCard: string;
}

export default function INVOICE_UP_LOADER_TS() {
  const [paymentAccounts, setPaymentAccounts] = useState<PaymentAccount[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const [pdfFileBase64, setPdfFileBase64] = useState<string | null>(null);
  const [pdfFile, setPdfFile] = useState<File | null>(null);
  const [xmlFileBase64, setXmlFileBase64] = useState<string | null>(null);
  const [xmlFile, setXmlFile] = useState<File | null>(null);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>("");
  const [selectedPaymentAccount, setSelectedPaymentAccount] = useState<string>("");

  const [invoices, setInvoices] = useState<any[]>([]);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState<boolean>(false);
  const [showOrderComponents, setShowOrderComponents] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [errors_status, setErrors_status] = useState<boolean>(false);

  const [activeTab, setActiveTab] = useState(0); // 0: Órdenes, 1: Facturas, 2: Ambos
  const fileTypes = ["PDF"];
  const fileTypes2 = ["XML"];

  const convertFileToBase64 = (file: File, callback: (error: Error | null, result: string | null) => void) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(null, reader.result as string);
    reader.onerror = () => callback(new Error("Error al leer el archivo"), null);
  };

  const handleFileUpload = useCallback(
    (file: File, setBase64: (value: string | null) => void, setFile: (value: File | null) => void) => {
      convertFileToBase64(file, (err, result) => {
        if (result) {
          setBase64(result);
          setFile(file);
        }
      });
    },
    []
  );

  const handlePdfUpload = (file: File) => handleFileUpload(file, setPdfFileBase64, setPdfFile);
  const handleXmlUpload = (file: File) => handleFileUpload(file, setXmlFileBase64, setXmlFile);

  const handlePaymentMethodChange = (event: ChangeEvent<{ value: unknown }>) => {
    const method = event.target.value as string;
    setSelectedPaymentMethod(method);
    const account = paymentAccounts.find((acc) => acc.payment_method === method);
    setSelectedPaymentAccount(account?.payment_account || "");
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setOpenModal(true);

    const pdfFileName = pdfFile?.name || "";
    const xmlFileName = xmlFile?.name || "";

    // Elimina la extensión
    const pdfNameWithoutExt = pdfFileName.replace(/\.pdf$/i, "");
    const xmlNameWithoutExt = xmlFileName.replace(/\.xml$/i, "");

    console.log("PDF File Base64:", pdfFileName);
    console.log("XML File Base64:", xmlFileName);

    // Comparación de nombres sin extensión
    if (pdfNameWithoutExt !== xmlNameWithoutExt) {
      alert("Los nombres de los archivos PDF y XML no coinciden.");
      setOpenModal(false);
      return;
    }

    const requestData: RequestData = {
      files: [
        { type: "xml", content: xmlFileBase64 ? xmlFileBase64.replace("data:text/xml;base64,", "") : "" },
        { type: "pdf", content: pdfFileBase64 ? pdfFileBase64.replace("data:application/pdf;base64,", "") : "" },
      ],
      paymentCard: selectedPaymentAccount,
    };

    try {
      const responseInvoice = await supplier_invoices_post(requestData);

      setInvoices([responseInvoice.data.invoice]);
      if (responseInvoice.data.invoice?.has_orders === false) {
        alert("DOCUMENTO ENVIADO CORRECTAMENTE");
        window.location.href = "/INVOICE_UP_LOADER_TS";
      } else {
        setIsSubmitSuccessful(false);
        setOpenConfirmDialog(true);
      }

    } catch (err: any) {
      alert(err?.response?.data?.errorMessage?.es);
      setIsSubmitSuccessful(false);
    } finally {
      setOpenModal(false);
    }
  };


  const handleConfirmYes = () => {
    setShowOrderComponents(true);
    setIsSubmitSuccessful(true);
    setOpenConfirmDialog(false);
  };

  const handleConfirmNo = () => {
    setOpenConfirmDialog(false);
    handleReset();
  };

  const handleReset = () => {

    setPdfFile(null);
    setXmlFile(null);
    setPdfFileBase64(null);
    setXmlFileBase64(null);
    setInvoices([]);
    setIsSubmitSuccessful(false);
    setShowOrderComponents(false);
    setSelectedPaymentMethod("");
    setSelectedPaymentAccount("");
    window.location.href = "/INVOICE_UP_LOADER_TS";

  };

  useEffect(() => {
    const fetchPaymentAccounts = async () => {
      try {
        const isTokenValid = await refresh_token();
        if (isTokenValid) {
          const response = await expense_payment_account_get();
          setPaymentAccounts(response.data);

          const defaultAccount = response.data.find((d: PaymentAccount) => d.default);
          if (defaultAccount) {
            setSelectedPaymentMethod(defaultAccount.payment_method);
            setSelectedPaymentAccount(defaultAccount.payment_account);
          }
        }
      } catch (err) {
        console.error("Error al obtener cuentas de pago:", err);
      }
    };

    fetchPaymentAccounts();
  }, []);

  return (
    <div>
      <MODAL_TABLE open={false} message={''} message2={''} modalGeneral={false} modalT={openModal} />

      {!isSubmitSuccessful && (
        <div>
          <BREADCRUMBS niveles={[{ label: "ENVÍO DE DOCUMENTOS", path: null }]} />
          <Box p={4} bgcolor="#fff" borderRadius="12px" boxShadow={1}>
            {/* Título */}
            <Typography variant="h5" align="center" fontWeight="bold" mb={4}>
              Envío de Documentos
            </Typography>

            {/* Pasos */}
            <Box display="flex" justifyContent="space-between" mb={4}>
              {[1, 2, 3].map((num, index) => (
                <Box key={num} display="flex" alignItems="center" flex={1}>
                  <Box
                    width={32}
                    height={32}
                    borderRadius="50%"
                    bgcolor="#1111d2"
                    color="white"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="bold"
                    mr={2}
                  >
                    {num}
                  </Box>
                  <Box>
                    <Typography fontWeight="bold">
                      {["Seleccione sus documentos", "Seleccione la cuenta", "Envíe sus documentos"][index]}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {[
                        "Arrastre o seleccione el PDF/XML en su apartado correspondiente.",
                        "Elija la cuenta de pago para este envío.",
                        "Haga clic en el botón de enviar para subir su documento."
                      ][index]}
                    </Typography>
                  </Box>
                  {index < 2 && (
                    <Box flexGrow={1} height="1px" bgcolor="#1111d2" mx={2} />
                  )}
                </Box>
              ))}
            </Box>

            {/* Mensaje informativo */}
            <Box display="flex" alignItems="center" gap={1} p={2} mb={4} bgcolor="#EEF4FF" borderRadius="8px">
              <InfoOutlinedIcon color="primary" />
              <Typography fontSize="14px" color="#344054">
                Puede enviar archivos PDF y XML. Los dos documentos son necesarios para completar el envío.
              </Typography>
            </Box>

            {/* Área de arrastrar archivos */}
            <Box display="flex" gap={3} flexWrap="wrap" justifyContent="center" mb={4}>
              {/* PDF */}
              <FileUploader handleChange={handlePdfUpload} name="pdfFile" types={["PDF"]}>
                <Box
                  border="2px dashed #FDA29B"
                  borderRadius="12px"
                  p={4}
                  width="280px"
                  textAlign="center"
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: '#FFF0F0' } }}
                >
                  <PictureAsPdfIcon sx={{ fontSize: 50, color: '#D92D20' }} />
                  <Typography fontWeight="bold" mt={1}>PDF</Typography>
                  <Typography fontSize="14px" color="text.secondary">
                    Arrastre o seleccione el PDF a enviar
                  </Typography>
                  {pdfFile && <Typography mt={1} fontSize="13px" color="green">{pdfFile.name}</Typography>}
                </Box>
              </FileUploader>

              {/* XML */}
              <FileUploader handleChange={handleXmlUpload} name="xmlFile" types={["XML"]}>
                <Box
                  border="2px dashed #B2DDFF"
                  borderRadius="12px"
                  p={4}
                  width="280px"
                  textAlign="center"
                  sx={{ cursor: 'pointer', '&:hover': { backgroundColor: '#F0F8FF' } }}
                >
                  <DescriptionIcon sx={{ fontSize: 50, color: '#1570EF' }} />
                  <Typography fontWeight="bold" mt={1}>XML</Typography>
                  <Typography fontSize="14px" color="text.secondary">
                    Arrastre o seleccione el XML a enviar
                  </Typography>
                  {xmlFile && <Typography mt={1} fontSize="13px" color="green">{xmlFile.name}</Typography>}
                </Box>
              </FileUploader>
            </Box>

            {/* Selección de cuenta */}
            <Typography fontWeight="bold" mb={1}>Seleccione la cuenta de pago</Typography>
            <TextField
              fullWidth
              select
              size="small"
              value={selectedPaymentMethod}
              onChange={handlePaymentMethodChange}
              SelectProps={{ native: true }}
              sx={{ mb: 4, bgcolor: "#fff", borderRadius: 1 }}
            >
              <option value="">Seleccione una cuenta</option>
              {paymentAccounts.map((option) => (
                <option key={option.payment_method} value={option.payment_method}>
                  {option.payment_method}
                </option>
              ))}
            </TextField>

            {/* Botón enviar */}
            <Box textAlign="center">
              <Button
                variant="contained"
                size="large"
                onClick={handleSubmit}
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                  backgroundColor: "#1111d2",
                  color: "#fff",
                  borderRadius: "8px",
                  px: 6,
                  py: 1.5,
                  "&:hover": {
                    backgroundColor: "#1111d2"
                  }
                }}
              >
                ENVIAR DOCUMENTOS
              </Button>
            </Box>
          </Box>
        </div>
      )}

      {isSubmitSuccessful && showOrderComponents && (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={2}
            py={1}
            sx={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <DescriptionIcon color="primary" />
              <Typography variant="subtitle1" fontWeight="bold">
                ENVÍO DE FACTURAS
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<UploadIcon />}
              onClick={handleReset}
              sx={{
                backgroundColor: "#173B8C",
                color: "#fff",
                borderRadius: "8px",
                paddingX: 2.5,
                paddingY: 1,
                textTransform: "uppercase",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#102b6e"
                }
              }}
            >
              Subir otra factura
            </Button>
          </Box>

          {/* Tabs */}
          {!errors_status && (
            <Box
              display="start-flex"
              border="1px solid #D0D5DD"
              borderRadius="10px"
              p="3px"
              bgcolor="#F9FAFB"
              mt={2}
              mx={2}
            >
              <Button
                onClick={() => setActiveTab(0)}
                sx={{
                  borderRadius: "8px",
                  px: 2,
                  py: 1,
                  minWidth: "150px",
                  backgroundColor: activeTab === 0 ? "#173B8C" : "transparent",
                  color: activeTab === 0 ? "#fff" : "#667085",
                  fontWeight: activeTab === 0 ? "bold" : "normal",
                  boxShadow: activeTab === 0 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
                  "&:hover": {
                    backgroundColor: activeTab === 0 ? "#102b6e" : "#F0F2F5"
                  },
                  textTransform: "none",
                  fontSize: "14px"
                }}
              >
                Órdenes de Compra
              </Button>

              <Button
                onClick={() => setActiveTab(1)}
                sx={{
                  borderRadius: "8px",
                  px: 2,
                  py: 1,
                  minWidth: "150px",
                  backgroundColor: activeTab === 1 ? "#173B8C" : "transparent",
                  color: activeTab === 1 ? "#fff" : "#667085",
                  fontWeight: activeTab === 1 ? "bold" : "normal",
                  boxShadow: activeTab === 1 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
                  "&:hover": {
                    backgroundColor: activeTab === 1 ? "#102b6e" : "#F0F2F5"
                  },
                  textTransform: "none",
                  fontSize: "14px"
                }}
              >
                Factura Subida
              </Button>

              <Button
                onClick={() => setActiveTab(2)}
                sx={{
                  borderRadius: "8px",
                  px: 2,
                  py: 1,
                  minWidth: "120px",
                  backgroundColor: activeTab === 2 ? "#173B8C" : "transparent",
                  color: activeTab === 2 ? "#fff" : "#667085",
                  fontWeight: activeTab === 2 ? "bold" : "normal",
                  boxShadow: activeTab === 2 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
                  "&:hover": {
                    backgroundColor: activeTab === 2 ? "#102b6e" : "#F0F2F5"
                  },
                  textTransform: "none",
                  fontSize: "14px"
                }}
              >
                Ambos
              </Button>
            </Box>
          )}


          <Box px={2} mt={2}>
            {activeTab === 0 && (
              <SUPPLIER_ORDERS
                setErrors_status={setErrors_status}
                breadcrumbs={false}
                rfc={invoices[0]?.rfc_business_partner}
                invoice={invoices[0]}
              />
            )}

            {activeTab === 1 && (
              <SUPPLIER_INVOICE
                breadcrumbs={false}
                invoice={invoices} />
            )}

            {activeTab === 2 && (
              <>
                <SUPPLIER_ORDERS
                  breadcrumbs={true}
                  setErrors_status={setErrors_status}
                  rfc={invoices[0]?.rfc_business_partner}
                  invoice={invoices[0]}
                />
                <Box mt={3} />
                <SUPPLIER_INVOICE
                  breadcrumbs={true}
                  invoice={invoices} />
              </>
            )}
          </Box>
        </>
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={handleConfirmNo}
        PaperProps={{
          sx: {
            backgroundColor: "#1A1A1A",
            color: "#fff",
            borderRadius: 2,
            p: 3,
            textAlign: "center",
            minWidth: "320px"
          }
        }}
      >
        {/* Ícono de éxito */}
        <Box display="flex" justifyContent="center" mb={2}>
          <CheckCircleIcon sx={{ fontSize: 50, color: "#00D47E" }} />
        </Box>

        {/* Título */}
        <DialogTitle sx={{ color: "#fff", fontWeight: "bold", fontSize: "1.2rem" }}>
          Factura subida con éxito
        </DialogTitle>

        {/* Mensaje */}
        <DialogContent>
          <Typography color="#B0B0B0">
            ¿Desea relacionarla con una orden de compra?
          </Typography>
        </DialogContent>

        {/* Botones */}
        <DialogActions sx={{ justifyContent: "center", mt: 2 }}>
          <Button
            onClick={handleConfirmNo}
            variant="outlined"
            sx={{
              color: "#FF4C4C",
              borderColor: "#FF4C4C",
              textTransform: "uppercase",
              px: 3,
              "&:hover": {
                backgroundColor: "#2C0000",
                borderColor: "#FF4C4C"
              }
            }}
          >
            NO
          </Button>
          <Button
            onClick={handleConfirmYes}
            variant="contained"
            sx={{
              backgroundColor: "#7F56D9",
              color: "#fff",
              textTransform: "uppercase",
              px: 3,
              "&:hover": {
                backgroundColor: "#5B33B3"
              }
            }}
          >
            SÍ
          </Button>
        </DialogActions>
      </Dialog>

    </div>

  );
}
